import { Box } from "@mui/material"

import CustomConditionalActionsTableServer from "../../../components/CustomConditionalActionsTableServerSide"
import { GlobalContext } from "../../../contexts/GlobalContext"
import { useContext, useState } from "react"
import { useNavigate } from "react-router-dom"
import getIconComponent from "../../utils/getIconComponent"
import {
  handleExportDataPdfLGScreen,
  handleExportDataPdfSMScreen,
  handleAllExportDataCSV,
} from "../../utils/reactTableActions/exportToolbarActions"

import normalFormatDate from "../../utils/date/DDMMYYYFormatDate"
import CustomFieldsetAccordion from "../../../components/CustomFieldsetAccordion"
import Swal from "sweetalert2"

import { useQueryClient } from "@tanstack/react-query"

import { api } from "../../../api"

const ACCIONES = {
  OPCION: "DETALLE A TITULARIDAD (DAT)",
  CREAR: "DAT CREAR",
  BUSCAR: "DAT LEER",
  EDITAR: "DAT EDITAR",
  ELIMINAR: "DAT ELIMINAR",
}

const DetalleATitularidad = () => {
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const { selectedMenuInfo } = useContext(GlobalContext)
  const [expandedFieldsetAccordion, setExpandedFieldsetAccordion] = useState(true)
  const handleToggleFieldsetAccordion = () => setExpandedFieldsetAccordion((prev) => !prev)
  return (
    selectedMenuInfo?.data?.barraAcciones?.find((action) => action?.acccaption === ACCIONES.OPCION) && (
      <CustomFieldsetAccordion
        title="DETALLE A TITULARIDAD"
        expanded={expandedFieldsetAccordion}
        onToggle={handleToggleFieldsetAccordion}
      >
        <br />
        <CustomConditionalActionsTableServer
          endpoint="/ActivacionDePredios/getAllInscripcionesTitularidad"
          errorMsgFilterSearch="Error en cargar datos"
          queryKeyModal="getAllInscripcionesTitularidad"
          perPage={10}
          rowActionsWidthTable={180}
          rowActions={(row) => {
            // Buscar todas las acciones necesarias
            const buscarAction = selectedMenuInfo?.data?.barraAcciones?.find(
              (action) => action?.acccaption === ACCIONES.BUSCAR,
            )
            const editarAction = selectedMenuInfo?.data?.barraAcciones?.find(
              (action) => action?.acccaption === ACCIONES.EDITAR,
            )
            const eliminarAction = selectedMenuInfo?.data?.barraAcciones?.find(
              (action) => action?.acccaption === ACCIONES.ELIMINAR,
            )

            const actions = [
              {
                label: buscarAction?.acccaption,
                key: buscarAction?.acccaption,
                // icon: <RemoveRedEyeIcon sx={{ color: "#14AFF7" }} />,
                icon: getIconComponent(buscarAction?.accnameicono, buscarAction?.acctipoico),
                onClick: (row) => {
                  navigate(`buscarDetalleA`, { state: row.original })
                },
              },
              {
                label: editarAction?.acccaption,
                key: editarAction?.acccaption,
                icon: getIconComponent(editarAction?.accnameicono, editarAction?.acctipoico),
                onClick: (row) => {
                  navigate("editarDetalleA", { state: row.original })
                },
              },
              {
                label: eliminarAction?.acccaption,
                key: eliminarAction?.acccaption,
                icon: getIconComponent(eliminarAction?.accnameicono, eliminarAction?.acctipoico),
                onClick: async (row) => {
                  const result = await Swal.fire({
                    title: "¿Está seguro que quiere eliminar esta titularidad?",
                    text: `ID Inscripción: ${row.original.titid} - Predio: ${row.original.preid}`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Sí, eliminar",
                    cancelButtonText: "Cancelar",
                    confirmButtonColor: "#d33",
                  })

                  if (result.isConfirmed) {
                    try {
                      await api.post("/ActivacionDePredios/deleteTitularidad", {
                        titid: row.original.titid,
                        preid: row.original.preid,
                      })

                      await Swal.fire({
                        title: "¡Eliminado!",
                        text: "La titularidad ha sido eliminada correctamente.",
                        icon: "success",
                        confirmButtonText: "Aceptar",
                        confirmButtonColor: "#196C87",
                      })

                      // Invalidar la query para refrescar los datos
                      queryClient.invalidateQueries({ queryKey: ["getAllInscripcionesTitularidad"] })
                    } catch (error) {
                      console.error("Error al eliminar:", error)
                      Swal.fire({
                        title: "Error",
                        text: error.response?.data?.message || "No se pudo eliminar la titularidad",
                        icon: "error",
                        confirmButtonText: "Aceptar",
                      })
                    }
                  }
                },
              },
            ]

            return actions
          }}
          topToolbarCustomActions={({ table, device }) => {
            const crearAction = selectedMenuInfo?.data?.barraAcciones?.find(
              (action) => action.acccaption === ACCIONES.CREAR,
            )
            const exportarAction = selectedMenuInfo?.data?.barraAcciones?.find(
              (action) => action.acccaption === "EXPORTAR",
            )
            const toolbarActions = [
              {
                label: crearAction?.acccaption,
                key: crearAction?.acccaption,
                icon: getIconComponent(crearAction?.accnameicono, crearAction?.acctipoico),
                onClick: () => {
                  navigate("crearDetalleA")
                },
              },
              {
                type: "dropdown",
                label: exportarAction?.acccaption,
                key: "exportarDropdown",
                icon: getIconComponent(exportarAction?.accnameicono, exportarAction?.acctipoico),
                actions: [
                  {
                    label: "Exportar PDF",
                    key: "exportarPDF",
                    icon: getIconComponent(exportarAction?.accnameicono, exportarAction?.acctipoico),
                    onClick: ({ columns, data }) => {
                      if (device === "sm") {
                        return handleExportDataPdfSMScreen(
                          columns,
                          data,
                          "Reporte de usuarios",
                          `Reporte de Usuarios ${new Date().toLocaleString()}`,
                        )
                      }
                      handleExportDataPdfLGScreen(
                        columns,
                        table.getCoreRowModel().rows,
                        "Reporte de usuarios",
                        `Reporte de Usuarios ${new Date().toLocaleString()}`,
                      )
                    },
                  },
                  {
                    label: "Exportar CSV",
                    key: "exportarCSV",
                    icon: getIconComponent(exportarAction?.accnameicono, exportarAction?.acctipoico),
                    onClick: ({ data }) => {
                      handleAllExportDataCSV(data, `Reporte de Usuarios ${new Date().toLocaleString()}`)
                    },
                  },
                ],
              },
            ]
            return toolbarActions
          }}
          columnsTable={[
            {
              accessorKey: "titid",
              header: "ID Inscripción",
              size: 180,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "preid",
              header: "Matrícula",
              size: 180,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "titadqpre",
              header: "Título de Adquisición",
              size: 200,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "titfecha",
              header: "Fecha de Titularidad",
              size: 180,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "tittipodocprop",
              header: "Tipo de Documento Propietario",
              size: 150,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "titidpropietario",
              header: "Cédula/RUC Propietario",
              size: 180,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "titnombresprop",
              header: "Nombre(s) Propietario(s)",
              size: 250,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "titporcenacc",
              header: "Porcentaje de Acciones",
              size: 150,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "titnotaria",
              header: "Notaría",
              size: 200,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "titestado",
              header: "Estado",
              size: 120,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "titfecisys",
              header: "Fecha Creación",
              size: 180,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "titusuisys",
              header: "Usuario Creación",
              size: 180,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
            {
              accessorKey: "titestisys",
              header: "Estación Creación",
              size: 180,
              Cell: ({ cell }) => <span>{cell.getValue()}</span>,
            },
          ]}
        />
      </CustomFieldsetAccordion>
    )
  )
}

export default DetalleATitularidad
